'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout     from '@Layout/BackOffice'
import UpdateForm from '@/Form/UpdateForm'
import config     from '@Config/Blog/blog'

import Link from '@Pure/Link'

export default class ECBlogUpdatePage extends React.Component
{
	constructor (props)
	{
		super(props);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let output =
		(
			<Layout page_title="Modifier un article de blog" history={ props.history }
				page_title_pathname="/accueil/mon-espace/blog/modifier-un-article-de-blog">

				<div className="page-content">

					<div className="o-content">

						<Link className="c-btn c-btn--extra c-btn--prev u-margin-bottom-10"
							href={ '/accueil/mon-espace/blog/' + id }>
							Retourner à l'article
						</Link>

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config } className="u-no-margin-top" />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}